import { render, staticRenderFns } from "./RightChat.vue?vue&type=template&id=1a1c9a2c&scoped=true&"
import script from "./RightChat.vue?vue&type=script&lang=js&"
export * from "./RightChat.vue?vue&type=script&lang=js&"
import style0 from "./RightChat.vue?vue&type=style&index=0&id=1a1c9a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c9a2c",
  null
  
)

export default component.exports